export const multipleArrayOptions = ['is any of', 'is not'];
export const singleArrayOptions = ['is', 'is not'];
export const arrayOptions = ['is any of', 'is'];
export const textOptions = ['contains', 'does not contain'];
export const numberOptions = ['is equal to', 'is less than', 'is more than'];
export const numberRangeOptions = ['amount range is', 'amount range is not'];
export const signatureStatusOptions = ['signed by', 'not signed by', 'awaiting signature by'];
export const presenceOptions = ['contains any value'];
